import { SECTION_IDS } from "./sectionIds";

export const navLinks = [
  {
    label: "About us",
    tKey: "layouts:navbarLabels.aboutUs",
    sectionID: SECTION_IDS.FINDER_PROMO,
    offsetTopDesktop: -150,
    offsetTopMobile: -100
  },
  {
    label: "Tools",
    tKey: "layouts:navbarLabels.tools",
    sectionID: SECTION_IDS.TOOLS,
    offsetTopDesktop: -100,
    offsetTopMobile: -100
  },
  {
    label: "Demo",
    tKey: "layouts:navbarLabels.demo",
    sectionID: SECTION_IDS.FINDER_DEMO,
    offsetTopDesktop: -100,
    offsetTopMobile: -100
  },
  {
    label: "Contact",
    tKey: "layouts:navbarLabels.contact",
    sectionID: SECTION_IDS.FOOTER,
    offsetTopDesktop: -100,
    offsetTopMobile: -100
  }
];
